import { SdohSingleAnswerAdvanced } from './SdohSingleAnswerAdvanced.model';

export default interface IOptionalAdditionalQuestions {
    DoYouFeelPhysicallyAndEmotionallySafe: SdohSingleAnswerAdvanced | null;
    HaveYouBeenAfraidOfYourPartner: SdohSingleAnswerAdvanced | null;
    IsAIDoYouFeelPhysicallyAndEmotionallySafe?: boolean;
    IsAIHaveYouBeenAfraidOfYourPartner?: boolean;
}

export class OptionalAdditionalQuestions implements IOptionalAdditionalQuestions {
    DoYouFeelPhysicallyAndEmotionallySafe: SdohSingleAnswerAdvanced | null;
    HaveYouBeenAfraidOfYourPartner: SdohSingleAnswerAdvanced | null;
    IsAIDoYouFeelPhysicallyAndEmotionallySafe?: boolean;
    IsAIHaveYouBeenAfraidOfYourPartner?: boolean;

    constructor() {
        this.DoYouFeelPhysicallyAndEmotionallySafe = new SdohSingleAnswerAdvanced();
        this.HaveYouBeenAfraidOfYourPartner = new SdohSingleAnswerAdvanced();
    }
}
